/**
 * Ресурси, картку яких можна позначити зірочкою «в обране».
 *
 * Обране — це закладки на робочі записи, до яких повертаються: клієнт,
 * перевізник, співробітник. Зірочка в довіднику чи на рядку журналу виглядала
 * б як недогляд, тож перелік явний, а не «усе, крім».
 *
 * Етап 1: клієнти (S4a), перевізники (S5a, `SPEC-014` Д16), співробітники
 * (`SPEC-014` §4.3, G-17); завдання — модуль з демки (`SPEC-018`, як у демці).
 *
 * Порядок — як у бічному меню: у цьому ж порядку стоять групи в шухляді
 * «Обране», і людина знаходить їх там, де звикла бачити розділи.
 *
 * ⚠️ Помилка в ключі не падає й нічого не ламає — зірочки на картці просто
 * не буде. Тому ключі звіряє вартовий у `architectureGuard.test.ts`.
 */
export const FAVORITE_RESOURCES = [
    'Crm.Client',
    'Crm.Carrier',
    // Етап 2 (`SPEC-025` §3.4.2): заявка, запит, тендер. «Рейси» зірочки не
    // мають — їхня картка та сама заявка
    'Transportation.Application',
    'Transportation.Request',
    'Transportation.Tender',
    'Task',
    'Setting.User',
]
